export default "__VITE_ASSET__Dd4WpVHL__"